import { Action } from '@ngrx/store';

// Constants
export const RESET_SEARCH_RESULTS = '[Core] Reset Search Results';
export const PARTICIPANT_OR_STATEMENT_SEARCH = '[Core] Making A Search For Participants or Statements';
export const SEARCH_FOR_PARTICIPANT_STATEMENT = '[Core] Searching For Participants or Statements';
export const SEARCH_FOR_PARTICIPANT_STATEMENT_SUCCESS = '[Core] Searching For Participants or Statements Success';

// Actions
export class ResetSearchResults implements Action {
  readonly type = RESET_SEARCH_RESULTS;
}
export class ParticipanStatementSearch implements Action {
  readonly type = PARTICIPANT_OR_STATEMENT_SEARCH;
}
export class SearchForParticipantStatement implements Action {
  readonly type = SEARCH_FOR_PARTICIPANT_STATEMENT;
  constructor(public payload: { search_word: string, project_id?: number }) {}
}
export class SearchForParticipantStatementSuccess implements Action {
  readonly type = SEARCH_FOR_PARTICIPANT_STATEMENT_SUCCESS;
  constructor(public payload: { participants: any[], statements: any[], rt_max_number: number }) {}
}

// Export Actions
export type Actions =
  | ResetSearchResults
  | ParticipanStatementSearch
  | SearchForParticipantStatement
  | SearchForParticipantStatementSuccess;



// WEBPACK FOOTER //
// ./src/app/core/actions/search.actions.ts